module.exports = __webpack_public_path__ + "static/media/Daniel Jacques Resume.7355f176.pdf";